var map = {
	"./ai-driven-insights-for-sme-decision-making.json": [
		4680,
		680
	],
	"./democratisation-of-corporate-decision-making.json": [
		5349,
		349
	],
	"./driving-innovation-through-collaboration.json": [
		5957,
		957
	],
	"./making-better-leadership-decisions-with-ai.json": [
		6669,
		669
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8659;
module.exports = webpackAsyncContext;